import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/react/24/outline'
import cx from 'classix'
import React from 'react'
import { usePagination, UsePaginationProps } from 'react-instantsearch'

export default function CustomPagination(props: UsePaginationProps) {
  const { currentRefinement, isFirstPage, isLastPage, nbPages, refine } = usePagination(props)

  const previousPageIndex = currentRefinement - 1
  const nextPageIndex = currentRefinement + 1

  function goPreviousPage() {
    if (!isFirstPage) refine(previousPageIndex)
  }

  function goNextPage() {
    if (!isLastPage) refine(nextPageIndex)
  }

  const renderPages = () => {
    const pageButtons: (number | 'dots')[] = []
    const total = nbPages
    const current = currentRefinement

    if (total <= 5) {
      for (let i = 0; i < total; i++) pageButtons.push(i)
    } else {
      pageButtons.push(0)

      if (current > 2) {
        pageButtons.push('dots')
      }

      const middlePages = [current - 1, current, current + 1].filter((p) => p > 0 && p < total - 1)
      pageButtons.push(...middlePages)

      if (current < total - 3) {
        pageButtons.push('dots')
      }

      pageButtons.push(total - 1)
    }

    return pageButtons.map((page, idx) =>
      page === 'dots' ? (
        <span key={`dots-${idx}`} className='px-2 text-white'>
          …
        </span>
      ) : (
        <button
          key={page}
          onClick={() => refine(page)}
          className={cx(
            'w-8 h-8 flex items-center justify-center rounded-full text-white',
            page === currentRefinement ? 'opacity-50' : 'hover:underline'
          )}
        >
          {page + 1}
        </button>
      )
    )
  }

  return (
    <div className='flex flex-shrink-0 justify-center lg3:justify-end items-center gap-2 text-white sm:mb-0 mb-14'>
      <button
        className={cx('rounded-full', isFirstPage ? 'invisible' : 'visible')}
        onClick={goPreviousPage}
        disabled={isFirstPage}
      >
        <ArrowLeftCircleIcon className='w-8 h-8' />
      </button>

      {renderPages()}

      <button
        className={cx('rounded-full', isLastPage ? 'invisible' : 'visible')}
        onClick={goNextPage}
        disabled={isLastPage}
      >
        <ArrowRightCircleIcon className='w-8 h-8' />
      </button>
    </div>
  )
}
